module.exports = __webpack_public_path__ + "static/media/location.dedef72d.svg";